import React from 'react';
import './MobileWhyChooseSection.css';
import { FaGraduationCap, FaUserTie, FaChalkboardTeacher, 
         FaLaptopCode, FaUsers } from 'react-icons/fa';

const MobileWhyChooseSection = () => {
  const features = [
    {
      icon: <FaGraduationCap />,
      title: "Expert Faculty",
      description: "Experienced mentors with proven track records"
    },
    {
      icon: <FaUserTie />,
      title: "Personal Attention",
      description: "One-on-one mentoring and guidance"
    },
    {
      icon: <FaChalkboardTeacher />,
      title: "Specialized Training",
      description: "Focused programs for defense & competitive exams"
    },
    {
      icon: <FaLaptopCode />,
      title: "Modern Approach",
      description: "Hybrid learning with latest technology"
    },
    {
      icon: <FaUsers />,
      title: "Peer Learning",
      description: "Collaborative study environment"
    }
  ];

  return (
    <section className="mobile-why-choose-section">
      <div className="mobile-why-choose-container">
        <h2 className="mobile-why-choose-title">Why Choose ADCI?</h2>
        <div className="flow-chart">
          {features.map((feature, index) => (
            <div key={index} className="feature-bubble">
              <div className="bubble-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              {index < features.length - 1 && <div className="connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileWhyChooseSection;
